<style lang="scss" scoped>
@import "./filePage.css";
.fontCla{
  margin-top: 15px ;
}
.content_pc .fontCla{
  margin-top: 8px ;
}
.fontCla1{
  margin: 10px 0;
  font-weight: 600;
}
.headerLogo {
    width: 12rem;
}
.one_bottom{
  // margin-bottom: 10px;
}
</style>

<template>
<div>
  <div class="content" v-if="false">
    <div v-for="(item,index) in parms.filepages_result" :key="index">
      <!-- 标题 -->
      <div class="title" v-if="item.bigtitle">{{item.bigtitle}}</div>
      <!-- 第一级 -->
      <div class="flex" :class="{title:item.titlenum}" v-if="item.jibie == 1">
        <span v-if="item.titlenum" class="numCla">{{item.titlenum}}</span>
        <span>{{item.title}}</span>
      </div>
      <!-- 第二级 -->
      <div class="flex file_1" v-if="item.jibie == 2" >
        <span v-if="item.titlenum" class="numCla1">{{item.titlenum}}</span>
        <span>{{item.title}}</span>
      </div>
      <!-- 第三级 -->
      <div class="flex file_2" v-if="item.jibie == 3">
        <span v-if="item.titlenum" class="numCla">{{item.titlenum}}</span>
        <span>{{item.title}}</span>
      </div>
      <!-- 第四级 -->
      <div class="flex file_3" v-if="item.jibie == 4">
        <span v-if="item.titlenum" class="numCla">{{item.titlenum}}</span>
        <span>{{item.title}}</span>
      </div>
    </div>
  </div>
  <div style="text-align: center;border-bottom: 10px solid rgb(238, 238, 238)" v-if="websta == 'pc'">
    <img src="../../image/logoHeader.png" class="headerLogo">
  </div>
  <div class="content_pc" style="padding:0 25%;" v-if="websta == 'pc'">
    <div v-for="(item,index) in parms.filepages_result" :key="index">
      <!-- 标题 -->
      <div class="title" v-if="item.bigtitle">{{item.bigtitle}}</div>
      <!-- 第一级 -->
      <div class="flex one_bottom" v-if="item.jibie == 1">
        <span v-if="item.titlenum" class="numCla fontCla" >{{item.titlenum}}</span>
        <span :style="item.boldFlag?'font-weight: 600;margin-top:15px;':'font-weight: 0;'" class="fontCla">{{item.title}}</span>
      </div>
      <!-- 第二级 -->
      <div class="flex file_1" v-if="item.jibie == 2" >
        <span v-if="item.titlenum" class="numCla1">{{item.titlenum}}</span>
        <span>{{item.title}}</span>
      </div>
      <!-- 第三级 -->
      <div class="flex file_2" v-if="item.jibie == 3">
        <span v-if="item.titlenum" class="numCla">{{item.titlenum}}</span>
        <span>{{item.title}}</span>
      </div>
      <!-- 第四级 -->
      <div class="flex file_3" v-if="item.jibie == 4">  
        <span v-if="item.titlenum" class="numCla">{{item.titlenum}}</span>
        <span>{{item.title}}</span>
      </div>
    </div>
  </div>
  <div class="content" v-else>
    <!-- <div v-if="name == 'StatementTerms'">
      <div v-for="(item,index) in parms.filepages_result" :key="index">
        <div class="title" v-if="item.bigtitle">{{item.bigtitle}}</div>
        <div class="flex" v-if="item.jibie == 1">
          <span v-if="item.titlenum" class="numCla" >{{item.titlenum}}</span>
          <span :style="item.boldFlag?'font-weight: 600;margin-top:15px;':'font-weight: 0;'" :class="{fontCla1:item.title=='客戶通知' || item.title=='釋義及說明'|| item.title=='客戶聲明'|| item.title=='重要事項'|| item.title=='免責聲明'}">{{item.title}}</span>
        </div>
        <div class="flex file_1" v-if="item.jibie == 2" >
          <span v-if="item.titlenum" class="numCla1">{{item.titlenum}}</span>
          <span>{{item.title}}</span>
        </div>
        <div class="flex file_2" v-if="item.jibie == 3">
          <span v-if="item.titlenum" class="numCla">{{item.titlenum}}</span>
          <span>{{item.title}}</span>
        </div>
        <div class="flex file_3" v-if="item.jibie == 4">
          <span v-if="item.titlenum" class="numCla">{{item.titlenum}}</span>
          <span>{{item.title}}</span>
        </div>
      </div>
    </div> -->
    <div > 
      <div v-for="(item,index) in parms.filepages_result" :key="index">
        <!-- 标题 -->
        <div class="title" v-if="item.bigtitle">{{item.bigtitle}}</div>
        <!-- 第一级 -->
        <div class="flex one_bottom" v-if="item.jibie == 1" >
          <span v-if="item.titlenum" class="numCla fontCla" >{{item.titlenum}}</span>
          <span :style="item.boldFlag?'font-weight: 600;':'font-weight: 0;'" class="fontCla">{{item.title}}</span>
        </div>
        <!-- 第二级 -->
        <div class="flex file_1" v-if="item.jibie == 2" >
          <span v-if="item.titlenum" class="numCla1">{{item.titlenum}}</span>
          <span>{{item.title}}</span>
        </div>
        <!-- 第三级 -->
        <div class="flex file_2" v-if="item.jibie == 3">
          <span v-if="item.titlenum" class="numCla">{{item.titlenum}}</span>
          <span>{{item.title}}</span>
        </div>
        <!-- 第四级 -->
        <div class="flex file_3" v-if="item.jibie == 4">
          <span v-if="item.titlenum" class="numCla">{{item.titlenum}}</span>
          <span>{{item.title}}</span>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import https from "@/plugins/http.js";

import apiUrl from "@/assets/api.js";

import App from "@/assets/app.js";

export default {
  data() {
    return {
      websta: sessionStorage["onlinestate"],
      parms:{
        filepages_result:[]

      },
      name:"",
      lan:"",

    };
  },
  mounted() {
    this.websta =  sessionStorage["onlinestate"]?sessionStorage["onlinestate"]:'pc';
    console.log(this.$route.query.name);
    this.name = this.$route.query.name;
    this.lan = this.$route.query.lan;
    if (this.name == 'StatementTerms') {
      if (this.lan == 'eng') {
        document.title = 'Declaration Statement relating to the Client Risk Profile Questionnaire';
      }else{
        document.title = '有關風險評估之聲明條款';
      }
    }
    this.getFilePages();
  },
  methods: {
    getFilePages() {
      console.log(location.protocol);
      var url;
      if(location.protocol == 'https:') {
        url = 'https://www.qmisgroup.com:2347/groupweb/getFilePages'
      }else{
        url = 'http://202.130.113.149:2347/groupweb/getFilePages'
      }
      https.fetchLoginPost(url, {
          lan:!this.lan?'big5':this.lan,
          pagename:this.name
        })
        .then((data) => {
          if (Object.is(data.qmiscode, 1000)) {
            this.parms = data
          } else {
            App.oTool.warningT(data.qmismsg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },


  },
};
</script>


